import { AsiDialogView } from '@asi-ngtools/lib';
import {Component} from "@angular/core";

@Component({
  selector: 'info-modal',
  templateUrl: './info.modal.html'
})
export class InfoModal extends AsiDialogView {

  title: string;
  question: string;
  confirmButton: string;

  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/modal/info/info.modal.ts